import React from "react";
import ReactQuill from "react-quill";

import "./TextEditor.css";

export default function TextEditor(props) {
  const { text, setText } = props;

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <div className="commentary-text-editor">
      <ReactQuill
        value={text}
        onChange={setText}
        modules={modules}
        formats={formats}
      ></ReactQuill>
    </div>
  );
}
